import { createApp } from "vue";
import { createPinia } from "pinia";
import piniaPluginPersistedstate from "pinia-plugin-persistedstate";
import vue3GoogleLogin from "vue3-google-login";
import { i18n } from "./i18n";
import { useLanguageStore } from "@/stores/language";
import vSelect from 'vue3-select';
import 'vue3-select/dist/vue3-select.css';

import "@/scss/app.scss";
import App from "@/App.vue";
import router from "@/router";

/*** Font Awesome Icons ***/
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import {
  faHome,
  faPerson,
  faLocationDot,
  faMagnifyingGlass,
  faEye,
  faEyeSlash,
  faChevronUp,
  faChevronDown,
  faFileUpload,
  faTrashCan,
  faTriangleExclamation,
  faPause,
} from "@fortawesome/free-solid-svg-icons"; // Added chevron icons

/*** Add icons to the library ***/
library.add(
  faHome,
  faPerson,
  faLocationDot,
  faMagnifyingGlass,
  faEye,
  faEyeSlash,
  faChevronUp, // Added
  faChevronDown, // Added
  faFileUpload,
  faTrashCan,
  faTriangleExclamation,
  faPause,
);

/*** VueTelInput ***/
import VueTelInput from "vue-tel-input";
import "../node_modules/vue-tel-input/dist/vue-tel-input.css";

/*** Vue3Toastify ***/
import Vue3Toastify from "vue3-toastify";
import "vue3-toastify/dist/index.css";

/*** V-Select ***/
import "vue3-select/dist/vue3-select.css";

/*** V-Tooltip ***/
import FloatingVue from "floating-vue";
import "floating-vue/dist/style.css";

/*** Creating App ***/
(async () => {
  const app = createApp(App);

  /*** Create & use Pinia Store ***/
  const pinia = createPinia();
  pinia.use(piniaPluginPersistedstate);
  app.use(pinia);

  // Locale aus LocalStorage wiederherstellen (falls vorhanden)
  const languageStore = useLanguageStore();
  const saved = localStorage.getItem("currentLangId");
  if (saved) languageStore.setLanguage(saved);

  // *** WICHTIG: Sprachtexte laden/mergen BEVOR gemountet wird ***
  await languageStore.setLanguageTexts();

  /*** Use the router in the Vue app ***/
  app.use(router);

  /*** Use i18n for internationalization ***/
  app.use(i18n);

  app.component("font-awesome-icon", FontAwesomeIcon);
  app.component("v-select", vSelect)

  /*** Use the VueTelInput in the Vue app ***/
  app.use(VueTelInput as any, {
    mode: "international",
    defaultCountry: "CH",
    preferredCountries: ["CH"],
    inputOptions: {
      placeholder: "+41 71 437 40 40",
    },
  });

  /*** Use the Vue3Toastify in the Vue app ***/
  app.use(Vue3Toastify, {
    autoClose: 5000,
    closeOnClick: false,
  });

  /*** Use the V-Tooltip in the Vue app ***/
  app.use(FloatingVue, {
    themes: {
      tooltip: {
        triggers: ["hover", "click", "touch"],
        delay: { show: 100, hide: 0 },
      },
    },
  });

  /*** Use vue3-google-login for Google SSO ***/
  app.use(vue3GoogleLogin, {
    clientId: import.meta.env.VITE_GOOGLE_CLIENT_ID,
  });

  app.mount("#vermittlungsportal-app");
})();
